export const SiteFooter = () => {
  return (
    <footer className="global-footer" data-testid="site-footer">
      <div className="footer-inner">
        <p className="footer-note" data-testid="footer-note">
          Art of Life · Gabriele Sauer
        </p>
        <nav className="footer-links" data-testid="footer-links">
          <a className="footer-link" href="/impressum.html" data-testid="footer-link-impressum">
            Impressum
          </a>
          <a className="footer-link" href="/datenschutz.html" data-testid="footer-link-datenschutz">
            Datenschutz
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;